const styles = {
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },

  tableContainer: {
    flex: 1
  },

  tripDetailsContainer: {
    marginTop: 2
  },

  tripDatesContainer: {
    display: 'flex',
    gap: 2
  }
}

export default styles
